module.exports = __webpack_public_path__ + "img/download.fb988b31.png";